async function getSiteVersion() {
	const siteVersionDataInp = document.getElementById("site-version-data");
	if (!siteVersionDataInp) return null;
	return Object.entries(siteVersionDataInp.dataset).reduce(
		(acc, [key, value]) => {
			if (value === "true") {
				acc[key] = true;
			} else if (value === "false") {
				acc[key] = false;
			} else {
				acc[key] = value;
			}
			return acc;
		},
		{},
	);
}

function setForceSelection(enabled) {
	if (enabled) {
		try {
			localStorage.setItem("site_version_required", "1");
		} catch (error) {}
	} else {
		try {
			localStorage.removeItem("site_version_required");
		} catch (error) {}
	}
}

async function setSiteVersion(siteVersionData, selectedVersion) {
	const cartAttributeData = {
		attributes: {
			site_version: selectedVersion,
			site_version_data: JSON.stringify(siteVersionData),
		},
	};

	try {
		await fetch("/cart/update.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "same-origin",
			body: JSON.stringify(cartAttributeData),
		});

		try {
			await fetch("/cart/clear.js", {
				method: "POST",
				credentials: "same-origin",
			});
		} catch (error) {}

		setForceSelection(false);
		try {
			localStorage.setItem("site_version_selected", Date.now().toString());
		} catch (error) {}
		try {
			localStorage.removeItem("site_version_required");
		} catch (error) {}

		window.location.href = "/";
	} catch (error) {
		setForceSelection(false);
		try {
			localStorage.setItem("site_version_selected", Date.now().toString());
		} catch (error) {}
		try {
			localStorage.removeItem("site_version_required");
		} catch (error) {}
		window.location.href = "/";
	}
}

function onVersionSelection(siteVersionData, version) {
	if (siteVersionData && version !== "") {
		siteVersionData.versionSelected = true;
		siteVersionData.needsVersionSelection = false;
		siteVersionData.whSelected = version === "wholesale";
		siteVersionData.kzSelected = version === "kitazawa";
		siteVersionData.hpSelected = version === "handy-pantry";

		if (version === "wholesale") {
			siteVersionData.isKitazawa = false;
			siteVersionData.isHp = false;
		} else if (version === "kitazawa") {
			siteVersionData.isWholesale = false;
			siteVersionData.isHp = false;
		} else if (version === "handy-pantry") {
			siteVersionData.isWholesale = false;
			siteVersionData.isKitazawa = false;
		}
	}
	return siteVersionData;
}

async function siteVersionSelector(event) {
	const clickedBtn = event.target;
	if (!clickedBtn) {
		return;
	}

	let version = "";
	switch (clickedBtn.id) {
		case "wholesale-select-button":
			version = "wholesale";
			break;
		case "kitazawa-select-button":
			version = "kitazawa";
			break;
		case "handy-pantry-select-button":
			version = "handy-pantry";
			break;
		default:
			return;
	}

	const siteVersionData = await getSiteVersion();
	const updatedData = onVersionSelection(siteVersionData, version);

	return setSiteVersion(updatedData, version);
}

async function clearVersionData() {
	await fetch("/cart/update.js", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		credentials: "same-origin",
		body: JSON.stringify({
			attributes: { site_version: "", site_version_data: "" },
		}),
	});

	await fetch("/cart/clear.js", {
		method: "POST",
		credentials: "same-origin",
	});
}

function switchCatalog(event) {
	if (!event || !event.target) return;
	setForceSelection(true);
	clearVersionData()
		.then(function () {
			try {
				localStorage.setItem("site_version_required", "1");
			} catch (error) {}
			window.location.href = "/pages/site-version-selection";
		})
		.catch(function () {
			try {
				localStorage.setItem("site_version_required", "1");
			} catch (error) {}
			window.location.href = "/pages/site-version-selection";
		});
}

(function initSiteVersionSelection() {
	function enableSelectionButtons() {
		try {
			document
				.querySelectorAll(".wholesale-card-catalog-selection-button")
				.forEach(function (btn) {
					btn.removeAttribute("disabled");
				});
		} catch (e) {}
	}

	setTimeout(enableSelectionButtons, 5000);

	function enforceRedirectIfRequired() {
		try {
			if (localStorage.getItem("site_version_required") === "1") {
				var pathname = location.pathname;
				if (
					pathname !== "/pages/site-version-selection" &&
					!pathname.startsWith("account") &&
					!pathname.includes("/orders") &&
					!pathname.includes(window.SITE_VERSION_LOGOUT_URL || "account/logout")
				) {
					location.href = "/pages/site-version-selection";
					return true;
				}
			}
		} catch (error) {}
		return false;
	}

	async function interceptClicksWhenRequired(event) {
		try {
			if (localStorage.getItem("site_version_required") !== "1") return;
			var pathname = location.pathname;
			var isTarget =
				event.target.closest &&
				(event.target.closest("a") || event.target.closest("button"));
			if (!isTarget) return;
			var href = isTarget.getAttribute && (isTarget.getAttribute("href") || isTarget.getAttribute("data-href") || isTarget.getAttribute("data-url"));
			var hasAction = isTarget.getAttribute && (href || isTarget.getAttribute("onclick") || isTarget.getAttribute("type") === "button" || isTarget.getAttribute("role") === "button");
			if (
				hasAction &&
				!(typeof href === "string" && href.startsWith("#")) &&
				pathname !== "/pages/site-version-selection" &&
				!pathname.startsWith("account") &&
				!pathname.includes("/orders") &&
				!pathname.includes(window.SITE_VERSION_LOGOUT_URL || "account/logout")
			) {
				if (typeof href === "string" && /^https?:\/\//i.test(href) && !href.includes(location.host)) return;
				event.preventDefault();
				location.href = "/pages/site-version-selection";
			}
		} catch (error) {}
	}

	async function clearIfOnSelectionPage() {
		try {
			const cartAttributeData = await getSiteVersion();
			if (!cartAttributeData || !cartAttributeData.onSelectionPage) return;

			setForceSelection(true);

			let cart;
			try {
				const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
				cart = await cartRes.json();
			} catch (event) {
				return;
			}

			const attributeData = cart && cart.attributes ? cart.attributes : {};
			const hasSiteVersion =
				attributeData.site_version && attributeData.site_version !== "";
			const hasSiteVersionData =
				attributeData.site_version_data &&
				attributeData.site_version_data !== "";

			if (hasSiteVersion || hasSiteVersionData) {
				try {
					await clearVersionData();
				} catch (error) {}
				try {
					sessionStorage.setItem("site_version_cleared", "true");
				} catch (error) {}
				location.reload();
			}
		} catch (error) {}
	}

function attachLogoutClear() {
    try {
        var logoutUrl = window.SITE_VERSION_LOGOUT_URL;
        if (!logoutUrl) return;
        document.addEventListener(
            "click",
            function (event) {
                var action =
                    event.target.closest &&
                    (event.target.closest("a") || event.target.closest("button"));
                if (!action) return;
                var href =
                    action.getAttribute &&
                    (action.getAttribute("href") ||
                        action.getAttribute("data-href") ||
                        action.getAttribute("data-url"));
                if (href !== logoutUrl) return;
                event.preventDefault();

                // ensure server-side/cart clears and logout complete before broadcasting
                (async function () {
                    try {
                        await fetch("/cart/update.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            credentials: "same-origin",
                            body: JSON.stringify({
                                attributes: { site_version: "", site_version_data: "" },
                            }),
                        });
                    } catch (e) {}
                    try {
                        await fetch("/cart/clear.js", {
                            method: "POST",
                            credentials: "same-origin",
                        });
                    } catch (e) {}
                    // try logout endpoint to let server clear session cookie
                    try {
                        await fetch(logoutUrl, { method: "GET", credentials: "same-origin", redirect: "follow" });
                    } catch (e) {}

                    try { localStorage.setItem("site_version_logout", Date.now().toString()); } catch (error) {}
                    try {
                        localStorage.removeItem("site_version_required");
                        localStorage.removeItem("site_version_selected");
                    } catch (error) {}
                    location.href = logoutUrl;
                })();
            },
            true,
        );
    } catch (error) {}
}
attachLogoutClear();

	window.addEventListener("storage", function (event) {
		try {
			if (event.key === "site_version_required") {
				if (event.newValue === "1") {
					if (location.pathname !== "/pages/site-version-selection") {
						location.href = "/pages/site-version-selection";
					}
					return;
				}
				if (event.newValue === null || event.newValue === "0") {
					if (location.pathname === "/pages/site-version-selection") {
						location.href = "/";
					}
					return;
				}
			}
			if (event.key === "site_version_selected" && event.newValue) {
				if (location.pathname === "/pages/site-version-selection") {
					location.href = "/";
				}
			}
            if (event.key === "site_version_logout" && event.newValue) {
                (function () {
                    try {
                        localStorage.removeItem("site_version_required");
                        localStorage.removeItem("site_version_selected");
                        sessionStorage.removeItem("site_version_cleared");
                    } catch (error) {}
                    if (location.pathname === "/pages/site-version-selection") {
                        location.href = "/";
                    } else {
                        location.reload();
                    }
                })();
            }
		} catch (error) {}
	});

	if (!enforceRedirectIfRequired()) {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", function () {
				document.addEventListener("click", interceptClicksWhenRequired, true);
				clearIfOnSelectionPage().finally(function () {
					enableSelectionButtons();
				});
			});
		} else {
			document.addEventListener("click", interceptClicksWhenRequired, true);
			clearIfOnSelectionPage().finally(function () {
				enableSelectionButtons();
			});
		}
	}
})();
